import { type Customer } from '.';
import {
  BaseEntity,
  JsonApiProperty,
  JsonApiRelationship,
  JsonApiResource,
} from '../jsonapi-provider';
import { LocalDate } from '../utils/local-date';

@JsonApiResource({
  type: 'special-event-master-settings',
})
export default class SpecialEventMasterSettings extends BaseEntity {
  isEnabled: boolean = true;
  @JsonApiProperty({ resolver: Number }) minNumberOfMeals: number = 50;
  @JsonApiProperty({ resolver: Number }) deadlineToOrder: number = 7;
  @JsonApiProperty({ resolver: (val: any) => new LocalDate(val) }) startDate = new LocalDate();
  @JsonApiProperty({ resolver: (val: any) => new LocalDate(val) }) endDate = new LocalDate().add(
    1,
    'd'
  );

  @JsonApiRelationship('customer') availableCustomers = new Array<Customer>();
  constructor(
    id?: SpecialEventMasterSettings['id'],
    isEnabled: SpecialEventMasterSettings['isEnabled'] = true,
    minNumberOfMeals: number = 50,
    deadlineToOrder: number = 7,

    startDate: SpecialEventMasterSettings['startDate'] = new LocalDate(),
    endDate: SpecialEventMasterSettings['endDate'] = new LocalDate(),
    availableCustomers: SpecialEventMasterSettings['availableCustomers'] = new Array<Customer>()
  ) {
    super();
    this.id = id;
    this.isEnabled = isEnabled;
    this.minNumberOfMeals = minNumberOfMeals;
    this.deadlineToOrder = deadlineToOrder;
    this.startDate = startDate;
    this.endDate = endDate;
    this.availableCustomers = availableCustomers;
  }
}
